import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "../styles/VerifyEmail.css";

const API_URL = process.env.REACT_APP_API_URL;

export default function EmailVerified() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying");

  useEffect(() => {
    const verifyEmail = async () => {
      const token = searchParams.get("token");
      if (!token) {
        setStatus("error");
        return;
      }

      try {
        const response = await fetch(`${API_URL}/verifyemail?token=${token}`);
        if (response.ok) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error(err);
        setStatus("error");
      }
    };

    verifyEmail();
  }, [searchParams]);

  return (
    <div className="ev-page">
      {/* Logo */}
      <div className="ev-logo-row">
        <div className="ev-logo-box">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff"
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
            <polyline points="14 2 14 8 20 8"/>
            <path d="M12 18v-6"/>
            <path d="M9 15l3-3 3 3"/>
          </svg>
        </div>
        <span className="ev-logo-name">ConvertPro</span>
      </div>

      {/* Card */}
      <div className="ev-card">
        {status === "verifying" && (
          <>
            <div className="ev-icon-circle ev-icon-verifying">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="#2563EB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 2v4M12 18v4M4.93 4.93l2.83 2.83M16.24 16.24l2.83 2.83M2 12h4M18 12h4M4.93 19.07l2.83-2.83M16.24 7.76l2.83-2.83"/>
              </svg>
            </div>
            <h1 className="ev-heading">Verifying...</h1>
            <p className="ev-subtext">Please wait while we verify your email address.</p>
          </>
        )}

        {status === "success" && (
          <>
            <div className="ev-icon-circle ev-icon-success">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="#16A34A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="20 6 9 17 4 12"/>
              </svg>
            </div>
            <h1 className="ev-heading">Email Verified!</h1>
            <p className="ev-subtext">
              Your email address has been successfully verified. You can now sign in to your account.
            </p>
            <button className="ev-cta-button" onClick={() => navigate("/login")}>
              Go to Login
            </button>
          </>
        )}

        {status === "error" && (
          <>
            <div className="ev-icon-circle ev-icon-error">
              <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
                stroke="#DC2626" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="15" y1="9" x2="9" y2="15"/>
                <line x1="9" y1="9" x2="15" y2="15"/>
              </svg>
            </div>
            <h1 className="ev-heading">Verification Failed</h1>
            <p className="ev-subtext">
              This verification link is invalid or has expired. Please request a new one.
            </p>
            <button className="ev-cta-button" onClick={() => navigate("/login")}>
              Go to Login
            </button>
          </>
        )}
      </div>

      {/* Footer */}
      <p className="ev-footer">&copy; 2026 ConvertPro. All rights reserved.</p>
    </div>
  );
}
